<app-loader-circles *ngIf="showLoader"></app-loader-circles>

<div class="modal-body ficha-exluida">
  <form [formGroup]="form" (submit)="submit()" class="centered flex-columns">
    <img
      src="assets/images/icons/icon-cancel.png"
      width="200"
      alt="ícone cancelar"
    />

    <h3 class="h3"><strong class="text-danger">Ficha Excluída!</strong></h3>

    <p class="size-20 mb-30">
      Você optou pelo cancelamento da proposta.
      <strong>Qual motivo levou essa decisão?</strong>
    </p>

    <div class="centered flex-columns align-start mb-30">
      <label
        formArrayName="motivos"
        *ngFor="let item of listFormArray?.controls; let i = index"
      >
        <input type="checkbox" [formControlName]="i" />
        <span class="radio-label">{{ listaMotivos[i].descricao }} </span>
      </label>

      <label *ngIf="outroMotivo" [for]="outroMotivo.id">
        <input
          [id]="outroMotivo.id"
          type="checkbox"
          name="outroMotivo"
          formControlName="outroMotivo"
        />
        <span class="radio-label">{{ outroMotivo.descricao }}</span>
      </label>
    </div>

    <input
      type="text"
      class="form-control"
      placeholder="Explique em poucas palavras o que aconteceu..."
      formControlName="justificativa"
      [hidden]="!form?.controls['outroMotivo']?.value"
      [required]="true"
    />

    <button
      type="submit"
      class="btn btn-full-orange"
      [disabled]="!form.valid && !checkboxValidator()"
    >
      Finalizar
    </button>
  </form>
</div>
